/* src/app/components/user-profile/user-profile.component.css */
.avatar-swatch {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid transparent;
  padding: 0;
  cursor: pointer;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);
}
.avatar-swatch--selected {
  border-color: var(--bg-surface);
  box-shadow: 0 0 0 2px var(--fg-1);
}
.avatar-swatch:focus-visible {
  outline: 2px solid var(--fg-1);
  outline-offset: 2px;
}
/*# sourceMappingURL=user-profile.component.css.map */
